import React from "react";
import { Calendar, GraduationCap } from "lucide-react";
import { formatDate } from "../utils/Config";

const EducationItem = ({ institution, degree, from, to, index }) => {
  // Generate a hash from institution name for consistent color
  const getBackgroundColor = (str) => {
    const colors = [
      'bg-blue-100 text-blue-700',
      'bg-purple-100 text-purple-700',
      'bg-green-100 text-green-700',
      'bg-rose-100 text-rose-700'
    ];
    const hash = str?.split('').reduce((acc, char) => char.charCodeAt(0) + acc, 0) || 0;
    return colors[hash % colors.length];
  };

  const initials = institution
    ?.split(' ')
    .map(word => word[0])
    .slice(0, 2)
    .join('')
    .toUpperCase() || '??';

  return (
    <div className="flex gap-4 py-4 group">
      <div className="flex-shrink-0">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getBackgroundColor(institution)} font-semibold transition-transform group-hover:scale-105`}>
          {initials}
        </div>
      </div>
      
      <div className="flex-grow space-y-1">
        <h3 className="font-semibold text-gray-900">{institution || 'Institution'}</h3>
        <div className="flex items-center gap-2 text-gray-600">
          <GraduationCap className="w-4 h-4" />
          <span>{degree || 'Degree'}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <Calendar className="w-4 h-4" />
          <span>
            {from ? formatDate(from) : 'Start Date'}
            {to && <span> - {formatDate(to)}</span>}
          </span>
        </div>
      </div>
    </div>
  );
};

const EducationSection = ({ user }) => {
  if (!user?.education?.length) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-6 w-full mx-auto mt-4">
        <h2 className="text-xl font-bold text-gray-900 mb-4">Education</h2>
        <p className="text-gray-500 italic">No education information available</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 w-full mx-auto mt-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-900">Education</h2>
      </div>

      <div className="divide-y divide-gray-200">
        {user.education.map((edu, index) => (
          <EducationItem
            key={`${edu.institution}-${index}`}
            {...edu}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default EducationSection;